


























import "./team-copy.less";
import Vue from "vue";
import iForm from "iView";
import moment from "moment";
import { Model } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import VueTagsInput from "@johmun/vue-tags-input";

let _ = require("lodash");

export default Vue.extend({
  name: "team-copy",
  components: {
    VueTagsInput
  },
  props: {
    team: Object,
    showEditor: Boolean
  },
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: "Please fill in the Team Name",
            trigger: "blur"
          },
          {
            type: "string",
            max: 40,
            message: "Please limit your Team Name to max 40 characters. Thanks!",
            trigger: "blur"
          }
        ],
        description: [
          {
            type: "string",
            max: 1200,
            message: "Please limit your Team Description to max 1,200 characters. Thanks!",
            trigger: "blur"
          }
        ],
        hashTagList: [
          {
            type: "array",
            required: true,
            message: "Please fill in the Grouping Tags"
          }
        ]
      },
      tag: "",
      tags: [],
      currentTeam: {
        name: null,
        description: "",
        hashTags: "",
        hashTagList: []
      }
    };
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        this.currentTeam.name = this.team.name;
        this.currentTeam.description = this.team.description;
        this.currentTeam.hashTags = this.team.hashTags;
        this.currentTeam.hashTagList = this.currentTeam.hashTags ? JSON.parse(this.currentTeam.hashTags) : [];
      }
    }
  },
  computed: {
    showModal(): any {
      return this.showEditor;
    }
  },
  methods: {
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.SetupForm as any).resetFields();
        } catch (error) {}
      }
    },
    handleSave() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      let form = this.$refs.TeamForm;

      (this.$refs.SetupForm as any).validate((valid: boolean) => {
        if (valid) {
          let teamDto = {
            id: this.team.id,
            name: this.currentTeam.name,
            description: this.currentTeam.description,
            hashTags: JSON.stringify(this.currentTeam.hashTagList)
          };

          let actionName = "team/copy";
          let context = this;
          context.$store.dispatch(actionName, { data: teamDto }).then(response => {
            context.$emit("cancel");
            target.disabled = false;
          });
        } else {
          target.disabled = false;
        }
      });
    }
  }
});
